import React from 'react';

const ButtonInput = ({
  label,
  disabled,
  buttonName,
  buttonCallback = () => {},
  inputContainerStyle={},
  buttonStyle={},
  title,
}) => (
  <div
    className="input-container"
    style={inputContainerStyle}
  >
    {label && 
      <div
        className="input-label"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          color: disabled ? "#9e9e9e" : "#333",
          flex: "1"
        }}
      >
        <span>{label}</span>
      </div>
    }
    <div
      style={{
        display: 'flex',
        flex: "1"
      }}
    >
      <div
        className="button"
        style={{
          backgroundColor: disabled ? "#d0d0d0" : "#9fd6ae",
          color: disabled ? "#888" : "#333",
          cursor: disabled ? "default" : "pointer",
          ...buttonStyle
        }}
        onClick={() => {
          if (!disabled) {
            buttonCallback()
          }
        }}
        title={title}
      >
        {buttonName}
      </div>
    </div>
  </div>
);

export default ButtonInput;
